import {newsPaging, ICenteredPage} from './newsPaging';

export async function fetchNewsItems (id: string, terms: string, sort: string, page: number, searchterm: string): Promise<number> {
    const newscategoriesCheckBoxes = [].slice.call(document.getElementsByName('newscategories')) as Array<HTMLInputElement>;
    const baseUrl:string = "/api/contentscategorysearch/getitems";
    const newsList:HTMLElement = <HTMLElement>document.getElementById('news-announcement-list');
    const categoryList:HTMLElement = <HTMLElement>document.getElementById(`newscategories_${id}`);
    
    try {
        const response = await window.fetch(`${baseUrl}?id=${id}&terms=${encodeURIComponent(terms)}&sort=${sort}&page=${page}&searchtext=${searchterm}`, { method: 'get', headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }) });
        const data = await response.json();
        let text:string = "";
        let categoryText:string = "";
        const newsPagination:HTMLElement = <HTMLElement>document.getElementById('newspagination');
        const shownewscount:HTMLElement = <HTMLElement>document.getElementById('shownewscount');

        if (!shownewscount) return;
        
        let startIndex:number = 1;
        let endIndex:number = data.pageSize > data.totalCount ? data.totalCount : data.pageSize;
        for (let item of data.contentItems) {
            //   console.log(item); 
            if (item.displayDateString != null && item.displayDateString != "" && data.displayOptions !== "card-3-across" && data.displayOptions !== "listing-with-image")
            {
                text += `<li class="directory-list-item">
                    <div class="directory-list-item-content">
                        <div class="has-preheading">
                            <h3 class="h4-style">
                                <a class="" href=" ${item.contentUrl}">
                                    ${item.contentTitle}
                                </a>
                            </h3>
                            <p class="preheading h6-style">
                            ${item.displayDateString}
                            </p>
                        </div>
                        ${item.contentDescription}
                    </div>
                </li>`
            }
            else if (item.author != null && item.author != "" || (item.displayDateString != null && item.displayDateString != "")  || item.imageUrl)
            {
                const displayText = item.author != null && item.author != "" ? item.author : item.displayDateString;
                if (data.displayOptions === "card-3-across")
                {
                    text += `<div class="card full">
                        <div class="card-inner block-inner">
                            <div class="rich-text card-content x-small">
                                
                                <h3 class="card-title half-margins"><a href="${item.contentUrl}">${item.contentTitle}</a></h3>
                                <p class="">${displayText}</p>
                            </div>
                            <div class="card-image">
                                <a href="${item.contentUrl}">
                                    <picture>
                                        <source sizes="100vw" srcset="${item.imageUrl}?format=webp&amp;width=300&amp;mode=crop&amp;heightratio=1&amp;quality=70 300w" type="image/webp">
                                        <source sizes="100vw" srcset="${item.imageUrl}?width=300&amp;mode=crop&amp;heightratio=1&amp;quality=70 300w">
                                        <img alt="${item.altText}" src="${item.imageUrl}?width=300&amp;mode=crop&amp;heightratio=1&amp;quality=70"
                                    </picture>
                                </a>
                            </div>
                        </div>
                    </div>`
                }
                else if (data.displayOptions === "listing-with-image")
                {
                    text += ` <div class="card full">
                                <div class="card-inner card-inline block-inner border-bottom" id="news-announcement-list">
                                    <div class="card-image">
                                        <picture>
                                            <source sizes="100vw" srcset="${item.imageUrl}?format=webp&amp;width=300&amp;mode=crop&amp;heightratio=1&amp;quality=70 300w" type="image/webp">
                                            <source sizes="100vw" srcset="${item.imageUrl}?width=300&amp;mode=crop&amp;heightratio=1&amp;quality=70 300w">
                                            <img alt="${item.altText}" src="${item.imageUrl}?width=300&amp;mode=crop&amp;heightratio=1&amp;quality=70"
                                        </picture>
                                    </div>
                                    <div class="card-content">
                                        <p class="">${item.displayDateString}</p>
                                        <h3 class="card-title title half-margins"><a href="${item.contentUrl}">${item.contentTitle}</a></h3>
                                        ${item.contentDescription}
                                    </div>
                                </div>
                            </div>`
                }
                else{
                    text += `<li class="directory-list-item">
                        <div class="directory-list-item-content">
                            <div class="has-preheading">
                                <p class="preheading h6-style">
                                ${displayText}
                                </p>
                                <h3 class="h4-style">
                                    <a class="" href=" ${item.contentUrl}">
                                        ${item.contentTitle}
                                    </a>
                                </h3>
                            </div>
                            ${item.contentDescription}
                           
                        </div>
                    </li>`
                }
            }
            else if (item.boardReportNumber != null && item.boardReportNumber != '')
            {
                text += `<li class="directory-list-item">
                    <div class="directory-list-item-content">
                        <div class="has-preheading">
                            <h3 class="h4-style">
                                <a class="" href=" ${item.contentUrl}">
                                    ${item.contentTitle}
                                </a>
                            </h3>
                            <p class="policy-section-intro">
                            <strong>Section</strong>
                            ${item.sectionNumber} | 
                            <strong>Board Report</strong>
                            ${item.boardReportNumber} | 
                            <strong>Date Adopted</strong>
                            ${new Date(item.dateAdopted).toLocaleDateString('en-US', {month: "long", day: '2-digit', year: 'numeric'})} 
                        </p>
                        <h5>
                            ${item.categoryString}
                        </h5>
                        </div>
                    </div>
                </li>`
            }
            else
            {
                text += `<li class="directory-list-item">
                    <div class="directory-list-item-content">
                        <div class="has-preheading">
                            <h3 class="h4-style">
                                <a class="" href=" ${item.contentUrl}">
                                    ${item.contentTitle}
                                </a>
                            </h3>
                            <p class="policy-section-intro">
                            <strong>Section</strong>
                            ${item.sectionNumber} 
                        </p>
                        <h5>
                            ${item.categoryString}
                        </h5>
                        </div>
                    </div>
                </li>`
            }
        }
        newsList.innerHTML = text;

        if (categoryList && (data.categoryGroups || data.categoryLists) && searchterm)
        {
            let i:number = 0;

            if (newscategoriesCheckBoxes)
            {
                newscategoriesCheckBoxes.forEach(checkbox => {
                    //console.log(checkbox);
                    let matches = [];
                    if (data.categoryGroups)
                    {
                        data.categoryGroups.forEach(function(e) {
                            if (e.categoryTerms)
                            {
                                matches = matches.concat(e.categoryTerms.filter(function(c) {
                                    return (c.categoryName === checkbox.value);
                                }));
                            }
                        });
                    }

                    if (data.categoryLists)
                    {
                        //console.log(checkbox.value);
                        matches = matches.concat(data.categoryLists.filter(
                                category => category.categoryName === checkbox.value
                        ));
                    }
                    
                    const label = document.querySelector('label[for="' + checkbox.id + '"]');
                    if (matches.length === 0)
                    {
                        if (label)
                        {
                            checkbox.disabled = true;
                            label.innerHTML = `${checkbox.value} (0)`;
                        }
                    }
                    else {
                        checkbox.disabled = false;
                        label.innerHTML = `${checkbox.value} (${matches[0].itemCount})`;
                    }
                });
            }
        }
        
        if (data.totalPages > 1)
        {
            startIndex = (page - 1) * data.pageSize + 1;
            endIndex = page < data.totalPages ? page * data.pageSize : data.totalCount; 
            newsPaging(data.pagePagination.centeredPages, data.totalPages, page, id, terms, sort, searchterm);
        }
        else
        {
            if (newsPagination)
            {
                newsPagination.innerHTML = '';
            }
        }

        if (data.totalCount === 0)
        {
            shownewscount.textContent = `No results to show`;
        }
        else {
            if (startIndex === endIndex)
            {
                shownewscount.textContent = `Showing ${startIndex} of ${data.totalCount}`;
            }
            else
            {
                shownewscount.textContent = `Showing ${startIndex} - ${endIndex} of ${data.totalCount}`;
            }
        }
        
        return data.totalPages;

    } catch (e) {
        console.log(e);
        return null;
    }
}
